import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import useDocs from '../../hooks/useDocs';
import { useAuth } from '../../contexts/AuthContext';

export default function UserRedirect() {
  const history = useHistory();
  const { currentUser } = useAuth();
  const { docs, loading, error } = useDocs('profiles');
  const username = docs?.username;

  useEffect(() => {
    if (username) {
      history.replace(`/user/${username}`);
    }
  }, [username, history]);

  if (!currentUser) {
    return (
      <p>
        Please <Link to="/login">log in</Link> to view your profile.
      </p>
    );
  }

  if (loading) {
    return <strong>Loading your profile...</strong>;
  }

  if (error) {
    return (
      <p>
        Could not load profile. Check your connection and try again.
        <br />
        <button type="button" onClick={() => window.location.reload()}>
          Retry
        </button>
      </p>
    );
  }

  if (!username) {
    return (
      <p>
        Username not found. Please complete your profile in{' '}
        <Link to="/update-profile">Update Profile</Link>.
      </p>
    );
  }

  return <strong>Redirecting you to your profile page...</strong>;
}
